import React from 'react';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faPlus from '@fortawesome/fontawesome-free-solid/faPlus';

const AddItemButton = () => (
  <div style={{ textAlign: 'right' }}>
    <Link to="/collections/add" className="button is-link">
      <FontAwesomeIcon icon={faPlus} className="icon" size="xs" />
      <span>Add Item</span>
    </Link>
  </div>
);

export default AddItemButton;



// WEBPACK FOOTER //
// ./src/components/pages/collections/AddItemButton.jsx